import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { business, navigation } from "../data";
import { CgMenuRight, CgClose } from "react-icons/cg";
import NavMobile from "./NavMobile";

const Header = () => {
	const [bg, setBg] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	// ===== CHECK ADMIN LOGIN STATUS =====
	const isAdmin = localStorage.getItem('adminAccess') === 'true';
	
	// ===== FILTER NAVIGATION - Hide admin from public =====
	const filteredNav = isAdmin 
		? navigation 
		: navigation.filter(item => item.name !== "admin");

	const bgStyle = bg ? "bg-blue-900 py-4 lg:py-6 shadow-lg" : "bg-blue-900/95 backdrop-blur-sm py-8";
	
	const navItems = filteredNav.map((item, index) => (
		<li key={index}>
			<Link
				to={item.href}
				className={`text-white capitalize hover:text-yellow-400 transition-all hover:border-b-2 hover:border-yellow-400 ${
					item.name === "admin" ? "bg-yellow-500 text-blue-900 px-4 py-1 rounded-full hover:bg-yellow-400 hover:text-blue-900 border-0" : ""
				}`}
			>
				{item.name === "admin" ? "⚙️ Admin" : item.name}
			</Link> 
		</li>
	));

	// Toggle mobile menu
	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};

	// Close mobile menu
	const closeMobileMenu = () => {
		setIsMobileMenuOpen(false);
	};

	// Prevent body scroll when menu is open
	useEffect(() => {
		if (isMobileMenuOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [isMobileMenuOpen]);

	// Handle scroll background
	useEffect(() => {
		const handleScroll = () => {
			setBg(window.scrollY > 50);
		};
		document.addEventListener("scroll", handleScroll);
		return () => document.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<>
			<section className={`${bgStyle} fixed w-full left-0 py-8 z-50 transition-all duration-200`}>
				<div className='container mx-auto'>
					<div className='flex justify-between items-center'>
						{/* Logo */}
						<Link to="/" className="flex flex-col">
							<span className="text-white text-3xl font-bold">{business.shortName}</span>
							<span className="text-yellow-400 text-sm tracking-[4px] uppercase">
								{business.category}
							</span>
						</Link>

						{/* Mobile Menu Button */}
						<button
							onClick={toggleMobileMenu}
							className='text-2xl text-white md:hidden lg:text-3xl cursor-pointer hover:text-yellow-400 transition-colors'
							aria-label="Toggle menu"
						>
							{isMobileMenuOpen ? <CgClose /> : <CgMenuRight />}
						</button>

						{/* Desktop Navigation */}
						<nav className='hidden md:flex'>
							<ul className='flex md:gap-x-12'>{navItems}</ul>
						</nav>
					</div>
				</div>
			</section>

			{/* Mobile Navigation */}
			<NavMobile isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
		</>
	);
};

export default Header;